import { render, staticRenderFns } from "./ProjectIssuesCountTableCell.vue?vue&type=template&id=306f7dd1&scoped=true"
import script from "./ProjectIssuesCountTableCell.vue?vue&type=script&lang=js"
export * from "./ProjectIssuesCountTableCell.vue?vue&type=script&lang=js"
import style0 from "./ProjectIssuesCountTableCell.vue?vue&type=style&index=0&id=306f7dd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306f7dd1",
  null
  
)

export default component.exports